/** Max width (px) for vendor main content column and stacked sections (profile cards, etc.). */
export const VENDOR_CONTENT_MAX_WIDTH_PX = 1320;

/**
 * MUI `sx` fragment: cap content width on large viewports and center it
 * inside the vendor main scroll area (scrollbar stays on the viewport edge).
 */
export const vendorMainColumnMaxWidthSx = {
  width: "100%",
  maxWidth: { xs: "100%", lg: `min(100%, ${VENDOR_CONTENT_MAX_WIDTH_PX}px)` },
  mx: "auto",
};
